// Module
var code = "<div class=\"ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle\" ng-bind=\"row.entity.date | localShort\"></div>\n</div>";
// Exports
module.exports = code;